<script>
export default {
  props: {
    title: { type: String, default: '' },
    content: { type: Array, default: () => [] },
    btnTo: { type: String, default: '' },
  },
  computed: {
    transContent() {
      if (this.content.length > 1) {
        return 'Multiple Values(' + this.content.length + ')'
      } else if (this.content.length === 1) {
        return typeof this.content[0] === 'string'
          ? this.content[0]
          : this.content[0].name
      } else {
        return ''
      }
    },
  },
}
</script>

<template>
  <v-layout
    align-center
    row>
    <v-flex xs2>
      <span class="sub-option-title">{{ title }}</span>
    </v-flex>
    <v-flex xs9>
      <span class="sub-option-content">{{ transContent }}</span>
    </v-flex>
    <v-flex
      xs1
      class="edit-btn">
      <v-btn
        :to="btnTo"
        block
        style="background-color: #243f92">Edit</v-btn>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.sub-option-title {
  color: #707070;
  font-size: 18px;
  display: inline-block;
  margin-right: 10px;
}
.sub-option-content {
  font-size: 18px;
}
.edit-btn >>> .btn__content {
  color: #ffffff;
}
</style>
